<template>
    <div class="row form-group">
        <div class="col col-md-3">
            <label for="text-input" class="form-control-label">
                <span class="input-required" v-if="isRequired" span>*</span>
                <span v-else>&nbsp;&nbsp;</span>
                {{label}}
            </label>
        </div>
        <div class="col-12 col-md-9">
            <vSelect
                label="label"
                :value="value"
                :placeholder="placeholder"
                :options="options"
                :reduce="option => nestedObj ? option : option.value"
                :disabled="disabled"
                @input="onInput"
            />
            <slot name="message-bottom"></slot>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: { vSelect },
  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Object,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    nestedObj: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default () { return [] }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput (value) {
      if (!value) {
        this.$emit('input', '')
        return
      }

      if (typeof value === 'object' && !this.nestedObj) {
        this.$emit('input', value.value)
        return
      }

      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
    .v-select {
        .vs__selected {
           color: #495057;
        }
       input {
           &::placeholder {
               color: rgba(#495057, .8)
           }
       }
    }
</style>
